module.exports = __webpack_public_path__ + "img/ecology_card4.2c976767.png";